import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { AUTH_API } from "./apiRoutes";

const mutateResetPasswordWithOtp = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${AUTH_API}/reset-password-with-otp`, data);
};

const useResetPasswordWithOtpMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateResetPasswordWithOtp,
    ...queryParams,
  });

export default useResetPasswordWithOtpMutation;
